module.exports = __webpack_public_path__ + "img/error-not-found.a008b49b.png";